import { send } from "@utils/fetch";
import { ActiveSubscriptionDataState } from "@utils/redux/slices/activeSubscriptionData";

export type SubscriptionStatusData = ActiveSubscriptionDataState & {
  planPrice?: number;
};

export function getSubscriptionStatus(version: "v1" | "v2" = "v2") {
  const url = `/visitor/api/${version}/getVisitorSubscriptionStatus/`;
  return send<SubscriptionStatusData>("GET", url);
}
